/* Funkelstück Relaunch – kleine, abhängigkeitsfreie Helfer (Slider-Pfeile, Quick-Add, Akkordeons) */
(function () {
  'use strict';

  /* Slider-Pfeile für horizontal scrollende Produktreihen */
  function initSliders(root) {
    (root || document).querySelectorAll('[data-fs-slider]').forEach(function (wrap) {
      if (wrap.dataset.fsSliderReady) return;
      wrap.dataset.fsSliderReady = '1';
      var track = wrap.querySelector('[data-fs-slider-track]');
      var prev = wrap.querySelector('[data-fs-slider-prev]');
      var next = wrap.querySelector('[data-fs-slider-next]');
      if (!track || !prev || !next) return;
      function step() {
        var item = track.querySelector('.grid__item');
        return item ? item.getBoundingClientRect().width : track.clientWidth * 0.8;
      }
      function update() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
        wrap.classList.toggle('fs-slider--static', max <= 2);
      }
      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initSliders(); });
  document.addEventListener('shopify:section:load', function (e) { initSliders(e.target); });
  window.fsRelaunch = { initSliders: initSliders };
})();

/* Schnell hinzufügen (Produktkarten) */
(function () {
  'use strict';
  function root() { return (window.theme && theme.routes && theme.routes.home ? theme.routes.home : '/').replace(/\/$/, ''); }

  window.fsAddVariant = addVariant;
  function addVariant(btn, variantId) {
    btn.classList.add('is-loading');
    return fetch(root() + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data && data.description ? data.description : 'Fehler');
        return data;
      });
    }).then(function () {
      btn.classList.remove('is-loading');
      btn.classList.add('is-added');
      setTimeout(function () { btn.classList.remove('is-added'); }, 1800);
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    }).catch(function (err) {
      btn.classList.remove('is-loading');
      window.alert(err.message);
    });
  }

  document.addEventListener('click', function (evt) {
    var add = evt.target.closest('[data-fs-quick-add]');
    if (add) {
      evt.preventDefault();
      addVariant(add, add.getAttribute('data-fs-quick-add'));
      return;
    }
  });
})();

/* Gewählten Wert neben jeder Varianten-Überschrift aktualisieren (z. B. „Buchstabe: A“) */
(function () {
  'use strict';
  document.addEventListener('change', function (evt) {
    var input = evt.target;
    if (!input.matches || !input.matches('.variant-input-wrap input[type="radio"]')) return;
    var wrapper = input.closest('.variant-wrapper');
    var span = wrapper && wrapper.querySelector('[data-fs-option-value]');
    if (span) span.textContent = input.value;
  });
})();

/* Warenkorb-Drawer: Gratisversand-Fortschritt, Upsell (Variante wählen + hinzufügen), bereits enthaltene Upsells ausblenden */
(function () {
  'use strict';
  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function refresh(drawer) {
    var items = drawer.querySelector('[data-products] .cart__items');
    if (!items) return;
    var subtotal = parseInt(items.getAttribute('data-cart-subtotal') || '0', 10);
    var ship = drawer.querySelector('[data-fs-ship]');
    var threshold = ship ? parseInt(ship.getAttribute('data-threshold') || '0', 10) : 0;
    if (ship && threshold > 0) {
      var left = threshold - subtotal;
      var text = ship.querySelector('[data-fs-ship-text]');
      var bar = ship.querySelector('[data-fs-ship-bar]');
      if (text) text.textContent = left > 0 ? ship.getAttribute('data-text-progress').replace('[betrag]', money(left)) : ship.getAttribute('data-text-done');
      if (bar) bar.style.width = Math.min(100, Math.round(subtotal / threshold * 100)) + '%';
    }
    var inCart = {};
    items.querySelectorAll('.cart__item[data-product-id]').forEach(function (el) { inCart[el.getAttribute('data-product-id')] = true; });
    drawer.querySelectorAll('[data-fs-upsell-product]').forEach(function (el) {
      el.hidden = !!inCart[el.getAttribute('data-fs-upsell-product')];
    });
    var upsell = drawer.querySelector('[data-fs-upsell]');
    if (upsell) upsell.hidden = !upsell.querySelector('[data-fs-upsell-product]:not([hidden])');
  }
  document.addEventListener('DOMContentLoaded', function () {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;
    var products = drawer.querySelector('[data-products]');
    if (products && window.MutationObserver) {
      new MutationObserver(function () { refresh(drawer); }).observe(products, { childList: true });
    }
  });
})();

/* Pflicht-Personalisierung: ohne Gravurtext kein Hinzufügen (Felder kommen von der Personalisierungs-App) */
(function () {
  'use strict';
  function fields(form) {
    return Array.prototype.filter.call(form.querySelectorAll('textarea, input[type="text"]'), function (el) {
      return el.offsetParent !== null && !el.closest('[data-fs-perso-error]');
    });
  }
  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('button[name="add"], .fs-sticky-atc__btn');
    if (!btn) return;
    var form = btn.form || (btn.getAttribute('form') && document.getElementById(btn.getAttribute('form'))) || btn.closest('form');
    if (!form || !form.querySelector('[data-fs-perso-required]')) return;
    var list = fields(form);
    if (!list.length) return; // Felder (noch) nicht geladen: App-Verhalten nicht blockieren
    var filled = list.some(function (el) { return el.value.trim() !== ''; });
    var msg = form.querySelector('[data-fs-perso-error]');
    if (!filled) {
      evt.preventDefault();
      evt.stopImmediatePropagation();
      if (msg) {
        msg.hidden = false;
        var target = form.querySelector('button[name="add"]');
        if (target && msg.nextElementSibling !== target) target.parentNode.insertBefore(msg, target);
      }
      list[0].focus();
      list[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
    } else if (msg) {
      msg.hidden = true;
    }
  }, true);
})();

/* Schnell hinzufügen mit Variantenwahl: eigenes Panel (mobil Bottom-Sheet, Desktop rechts).
   Daten kommen live aus /products/<handle>.js; Hinzufügen über /cart/add.js. */
(function () {
  'use strict';
  var root = (window.theme && theme.routes && theme.routes.home ? theme.routes.home : '/').replace(/\/$/, '');
  var sheet, lastTrigger, state = null;

  function money(cents) {
    if (window.theme && theme.Currency && theme.settings) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  function esc(str) { var d = document.createElement('div'); d.textContent = str == null ? '' : String(str); return d.innerHTML; }
  function isColor(name) { return /farbe|color|colour|veredelung/i.test(name); }
  var metal = {
    'gold': 'linear-gradient(135deg,#f6e3a1 0%,#d8b24c 52%,#f2d98a 100%)',
    'silber': 'linear-gradient(135deg,#f6f6f6 0%,#c4c6c9 52%,#eceded 100%)',
    'rose gold': 'linear-gradient(135deg,#f6d6c8 0%,#d69a85 52%,#f0c5b4 100%)',
    'roségold': 'linear-gradient(135deg,#f6d6c8 0%,#d69a85 52%,#f0c5b4 100%)',
    'schwarz': '#1c1c1c', 'weiß': '#fff', 'rot': '#b8352e', 'rosa': '#f2b8c6', 'babyblau': '#a9c8e8',
    'navyblau': '#22304d', 'grün': '#2f6b3d', 'gelb': '#f0c94a', 'lila': '#8a6bb8'
  };

  function build() {
    sheet = document.createElement('div');
    sheet.className = 'fs-qa';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="fs-qa__overlay" data-fs-qa-close></div>' +
      '<div class="fs-qa__panel" role="dialog" aria-modal="true" aria-labelledby="FsQaTitle" tabindex="-1">' +
      '<button type="button" class="fs-qa__close" data-fs-qa-close aria-label="Schließen"><svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"><path d="M6 6l12 12M18 6 6 18"/></svg></button>' +
      '<div class="fs-qa__body" data-fs-qa-body></div></div>';
    document.body.appendChild(sheet);
    sheet.addEventListener('click', function (e) {
      if (e.target.closest('[data-fs-qa-close]')) { close(); return; }
      var opt = e.target.closest('[data-fs-qa-opt]');
      if (opt && !opt.disabled) { select(+opt.getAttribute('data-fs-qa-index'), opt.getAttribute('data-fs-qa-opt')); return; }
      if (e.target.closest('[data-fs-qa-add]')) add(e.target.closest('[data-fs-qa-add]'));
    });
    sheet.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
      if (e.key === 'Tab') {
        var f = sheet.querySelectorAll('button:not([disabled]), a[href]');
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });
  }

  function current() {
    if (!state) return null;
    return state.product.variants.find(function (v) {
      return v.options.every(function (val, i) { return val === state.selected[i]; });
    }) || null;
  }
  function availableWith(index, value) {
    return state.product.variants.some(function (v) {
      if (!v.available || v.options[index] !== value) return false;
      return v.options.every(function (val, i) { return i === index || i > index || val === state.selected[i]; });
    });
  }
  function select(index, value) { state.selected[index] = value; render(); }

  function render() {
    var p = state.product, v = current();
    var img = (v && v.featured_image && v.featured_image.src) || p.featured_image;
    var html = '<div class="fs-qa__head">' +
      (img ? '<img class="fs-qa__img" src="' + img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=240" alt="" width="96" height="96">' : '') +
      '<div><p class="fs-qa__title" id="FsQaTitle">' + esc(p.title) + '</p><p class="fs-qa__price">';
    if (v) {
      html += '<span class="' + (v.compare_at_price > v.price ? 'fs-qa__sale' : '') + '">' + money(v.price) + '</span>';
      if (v.compare_at_price > v.price) html += ' <s>' + money(v.compare_at_price) + '</s>';
    }
    html += '</p><a class="fs-qa__more" href="' + root + '/products/' + p.handle + (v ? '?variant=' + v.id : '') + '">Alle Details</a></div></div>';
    p.options.forEach(function (opt, i) {
      var name = typeof opt === 'string' ? opt : opt.name;
      var values = typeof opt === 'string' ? [] : opt.values;
      if (!values.length) { values = []; p.variants.forEach(function (va) { if (values.indexOf(va.options[i]) === -1) values.push(va.options[i]); }); }
      var color = isColor(name);
      html += '<fieldset class="fs-qa__opt"><legend>' + esc(name.trim()) + ': <span>' + esc(state.selected[i]) + '</span></legend><div class="fs-qa__vals' + (color ? ' fs-qa__vals--swatch' : '') + '">';
      values.forEach(function (val) {
        var on = state.selected[i] === val, avail = availableWith(i, val);
        var style = color ? ' style="background:' + (metal[val.toLowerCase()] || '#d9d4ce') + '"' : '';
        html += '<button type="button" class="fs-qa__val' + (on ? ' is-on' : '') + (avail ? '' : ' is-na') + '" data-fs-qa-index="' + i + '" data-fs-qa-opt="' + esc(val) + '" aria-pressed="' + on + '"' + style + ' title="' + esc(val) + '">' + (color ? '<span class="visually-hidden">' + esc(val) + '</span>' : esc(val)) + '</button>';
      });
      html += '</div></fieldset>';
    });
    var can = v && v.available;
    html += '<button type="button" class="btn fs-qa__add" data-fs-qa-add ' + (can ? '' : 'disabled') + '>' + (v ? (can ? 'In den Warenkorb' : 'Ausverkauft') : 'Nicht verfügbar') + '</button>';
    sheet.querySelector('[data-fs-qa-body]').innerHTML = html;
  }

  function open(handle, trigger) {
    if (!sheet) build();
    lastTrigger = trigger;
    trigger.classList.add('is-loading');
    fetch(root + '/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (product) {
        var first = product.variants.find(function (v) { return v.available; }) || product.variants[0];
        state = { product: product, selected: first.options.slice() };
        render();
        sheet.hidden = false;
        document.documentElement.classList.add('fs-qa-open');
        requestAnimationFrame(function () { sheet.classList.add('is-open'); sheet.querySelector('.fs-qa__panel').focus(); });
      })
      .catch(function () { window.location.href = root + '/products/' + handle; })
      .then(function () { trigger.classList.remove('is-loading'); });
  }
  function close() {
    if (!sheet || sheet.hidden) return;
    sheet.classList.remove('is-open');
    document.documentElement.classList.remove('fs-qa-open');
    setTimeout(function () { sheet.hidden = true; }, 250);
    if (lastTrigger) lastTrigger.focus();
  }
  function add(btn) {
    var v = current();
    if (!v || !v.available) return;
    btn.disabled = true; btn.textContent = 'Wird hinzugefügt …';
    fetch(root + '/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: v.id, quantity: 1 }] })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || 'Fehler'); }); })
      .then(function () { close(); document.dispatchEvent(new CustomEvent('ajaxProduct:added')); })
      .catch(function (e) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; window.alert(e.message); });
  }

  document.addEventListener('click', function (evt) {
    var t = evt.target.closest('[data-fs-quick-sheet]');
    if (!t) return;
    evt.preventDefault();
    open(t.getAttribute('data-fs-quick-sheet'), t);
  });
})();

/* Entfernen im Warenkorb-Drawer per AJAX (statt Seitenwechsel auf /cart) */
document.addEventListener('click', function (evt) {
  var a = evt.target.closest('#CartDrawer .cart__remove a');
  if (!a) return;
  var item = a.closest('.cart__item');
  if (!item || !item.getAttribute('data-key')) return;
  evt.preventDefault();
  item.style.opacity = '.4';
  document.dispatchEvent(new CustomEvent('cart:quantity.cart-cart-drawer', { detail: [item.getAttribute('data-key'), '0', item] }));
});

/* Variantenwahl in kompakten Listen (Oft zusammen gekauft, Warenkorb-Upsell):
   Auswahl setzt die Varianten-ID für „Schnell hinzufügen“ und aktualisiert den Preis. */
document.addEventListener('change', function (evt) {
  var select = evt.target.closest('[data-fs-variant-select]');
  if (!select) return;
  var scope = select.closest('[data-fs-variant-scope]');
  if (!scope) return;
  var opt = select.options[select.selectedIndex];
  var btn = scope.querySelector('[data-fs-quick-add]');
  if (btn && opt) btn.setAttribute('data-fs-quick-add', opt.value);
  var price = scope.querySelector('[data-fs-variant-price]');
  if (price && opt && opt.getAttribute('data-price')) {
    var p = opt.getAttribute('data-price'), c = opt.getAttribute('data-compare');
    price.innerHTML = c ? '<span class="fs-price-sale"></span> <s></s>' : '<span></span>';
    price.querySelector('span').textContent = p;
    if (c) price.querySelector('s').textContent = c;
  }
});

/* Lieferzeit & Klarna: direkt vor den Warenkorb-Button setzen (also auch unter Gravurfelder,
   die Personalisierungs-Apps in das Formular einfügen) und Lieferzeit je Variante zeigen. */
(function () {
  'use strict';
  function place() {
    document.querySelectorAll('[data-fs-buy-info]').forEach(function (info) {
      var section = info.closest('.product-section');
      var btn = section && section.querySelector('.product-single__form button[name="add"]');
      if (btn && btn.previousElementSibling !== info) btn.parentNode.insertBefore(info, btn);
    });
  }
  function watch() {
    place();
    if (!window.MutationObserver) return;
    document.querySelectorAll('.product-section .product-single__form').forEach(function (form) {
      var obs = new MutationObserver(place);
      obs.observe(form, { childList: true });
      setTimeout(function () { obs.disconnect(); }, 15000);
    });
  }
  document.addEventListener('DOMContentLoaded', watch);
  window.addEventListener('load', place);
  document.addEventListener('variant:change', function (evt) {
    var v = evt.detail && evt.detail.variant;
    document.querySelectorAll('[data-fs-delivery]').forEach(function (row) {
      row.hidden = !(v && (row.getAttribute('data-ship-ids') || '').indexOf(',' + v.id + ',') !== -1);
    });
  });
})();
